import envSpecificConfig from './config.json';
import globalConfig from './config.global.json';

export default {
  ...envSpecificConfig,
  ...globalConfig,
  isProd: () => (envSpecificConfig.env === "production")
}
